import request from "../utils/request";


export function saveFavoriteElectricNumber(data) {
    return request({
        method: 'post',
        url: 'w/bill/saveFavoriteElectricityNumber',
        data: data,
    })
}

export function queryFavoriteElectricNumber() {
    return request({
        method: 'POST',
        url: 'w/bill/queryFavoriteElectricityNumber',
        data: {},
    })
}

export function deleteFavoriteElectricNumber(data) {
    return request({
        method: 'POST',
        url: 'w/bill/deleteFavoriteElectricityNumber',
        data: data,
    })
}


export function saveFavoriteWaterNumber(data) {
    return request({
        method: 'post',
        url: 'w/bill/saveFavoriteWaterNumber',
        data: data,
    })
}

export function queryFavoriteWaterNumber() {
    return request({
        method: 'POST',
        url: 'w/bill/queryFavoriteWaterNumber',
        data: {},
    })
}

export function deleteFavoriteWaterNumber(data) {
    return request({
        method: 'POST',
        url: 'w/bill/deleteFavoriteWaterNumber',
        data: data,
    })
}

export function saveFavoriteTaiwanWaterNumber(data) {
    return request({
        method: 'post',
        url: 'w/bill/saveFavoriteTaiwanWaterNumber',
        data: data,
    })
}

export function queryFavoriteTaiwanWaterNumber() {
    return request({
        method: 'POST',
        url: 'w/bill/queryFavoriteTaiwanWaterNumber',
        data: {},
    })
}

export function deleteFavoriteTaiwanWaterNumber(data) {
    return request({
        method: 'POST',
        url: 'w/bill/deleteFavoriteTaiwanWaterNumber',
        data: data,
    })
}


export function saveFavoriteCarNumber(cityId, data) {
    if (cityId === 'taipei') {
        return request({
            method: 'POST',
            url: 'w/bill/saveFavoriteCarNumber',
            data: data,
        });
    } else {
        return request({
            method: 'POST',
            url: 'w/bill/' + cityId + '/saveFavoriteCarNumber',
            data: data,
        });
    }
}

export function queryFavoriteCarNumber(cityId) {
    if (cityId === 'taipei') {
        return request({
            method: 'POST',
            url: 'w/bill/queryFavoriteCarNumber',
            data:{}
        });
    } else {
        return request({
            method: 'POST',
            url: 'w/bill/' + cityId + '/queryFavoriteCarNumber',
            data:{}
        });
    }
}

export function deleteFavoriteCarNumber(cityId, data) {
    if (cityId === 'taipei') {
        return request({
            method: 'POST',
            url: 'w/bill/deleteFavoriteCarNumber',
            data: data
        });
    } else {
        return request({
            method: 'POST',
            url: 'w/bill/' + cityId + '/deleteFavoriteCarNumber',
            data: data
        });
    }
}

export function saveFavoriteMedicalInformation(cityId, data) {
    return request({
        method: 'POST',
        url: 'w/bill/saveFavoriteMedicalInformation',
        data: data,
    })
}

export function deleteFavoriteMedicalInformation(data) {
    return request({
        method: 'POST',
        url: 'w/bill/deleteFavoriteMedicalInformation',
        data: data,
    })
}

export function queryFavoriteMedicalInformation() {
    return request({
        method: 'POST',
        url: 'w/bill/queryFavoriteMedicalInformation',
        data:{}
    })
}

export function queryCardless() {
    return request({
        method: 'POST',
        url: 'w/bill/paytaipei/cardlessQuery',
        data:{},
    })
}

export function cardlessBinding(data) {
    return request({
        method: 'POST',
        url: 'w/bill/paytaipei/cardlessBinding',
        data:data,
    })
}

export function cardlessUnbind(data) {
    return request({
        method: 'POST',
        url: 'w/bill/paytaipei/cardlessUnbind',
        data:data,
    })
}

export function verifyCarrierNumber(data) {
    return request({
        method: 'POST',
        url: 'w/bill/verifyCarrierNumber',
        data: data,
    })
}

export function queryBillList(data) {
    if (false) {
        let promise = new Promise((resolve, reject) => {
            data = JSON.parse('{"payment_method_list":[{"payment_method":"BALANCE","payment_method_name":"悠遊付錢包","payment_method_short_name":"悠遊付錢包","payment_method_remark":"$61,722","is_default":false,"is_default_deposit_method":false,"is_supported":true,"payment_method_serial_number":null,"payment_method_image_url":"https://epgwt.easycard.com.tw/uupay-api-merchant/img/uupay_logo/icon/icon_esay_wallet.png"}],"biller_nick_name":"測試學校","btypeClass":"0707","is_allow_merge":"N","transaction_number":"2022010600000013","bill_list":[{"payment_custom_id":null,"amount":10,"btId":"TWNCH|2022010600000013|01","field1_name":null,"field1_value":null,"field2_name":null,"field2_value":null,"field3_name":null,"field3_value":null,"field4_name":null,"field4_value":null,"field5_name":null,"field5_value":null,"field6_name":null,"field6_value":null,"field7_name":null,"field7_value":null,"field8_name":null,"field8_value":null,"field9_name":null,"field9_value":null,"field10_name":null,"field10_value":null,"bill_end_time":"2022/12/31 00:00:00","transaction_fee":6}],"carrierNumber":"/3SNWMXY"}');    
            resolve(data);
        });
        
        return promise;
    } else {    
        return request({
            method: 'POST',
            url: 'w/bill/queryBill',
            data: data,
        })
    }
}

export function saveChildBinding(data) {
    return request({
        method: 'POST',
        url: 'w/bill/saveChildBinding',
        data: data,
    })
}

export function deleteChildBinding(data) {
    return request({
        method: 'POST',
        url: 'w/bill/deleteChildBinding',
        data: data,
    })
}
export function queryChildBinding() {
    return request({
        method: 'POST',
        url: 'w/bill/queryChildBinding ',
        data: {},
    })
}

export function queryChildCanBind() {
    return request({
        method: 'POST',
        url: 'w/bill/queryChildCanBind',
        data: {},
    })
}

export function saveCityChildBinding(cityName, studentSid) {
    let data = {
        student_sid: studentSid,
    };
    return request({
        method: 'POST',
        url: 'w/bill/' + cityName + '/tuitionFee/saveChildBinding',
        data: data,
    })
}

export function deleteCityChildBinding(cityName, bindSerialNumber) {
    let data = {
        parent_child_bind_serial_number: bindSerialNumber,
    };
    return request({
        method: 'POST',
        url: 'w/bill/' + cityName + '/tuitionFee/deleteChildBinding',
        data: data,
    })
}
export function queryCityChildBinding(cityName) {
    return request({
        method: 'POST',
        url: 'w/bill/' + cityName + '/tuitionFee/queryChildBinding',
        data: {},
    })
}

export function queryCityChildRelation(cityName, studentIdNumber) {
    let data = {
        student_id_number: studentIdNumber,
    };
    return request({
        method: 'POST',
        url: 'w/bill/' + cityName + '/tuitionFee/queryChildRelation',
        data: data,
    })
}

export function queryCitySupportShoolList(cityName) {
    return request({
        method: 'POST',
        url: 'w/bill/' + cityName + '/tuitionFee/querySupportSchoolList',
        data: {},
    })
}

export function getBanner () {
    return request({
        method: 'get',
        url: 'm/advertisement/get?with_detail=1'
    })
}

export function getConfig (data) {
    return request({
        method: 'POST',
        url: 'w/bill/getConfig',
        data:data
    })
}

export function getInviteCode () {
    return request({
        method: 'post',
        url: 'w/bill/user/getReferralCode',
        data: {}
    })
}

export function queryHouseFeeBindingInformation () {
    return request({
        method: 'post',
        url: 'w/bill/queryHouseFeeBindingInformation',
        data: {}
    })
}

export function unbindHouse () {
    return request({
        method: 'post',
        url: 'w/bill/unbindHouseFee',
        data: {}
    })
}

export function bindHouse () {
    return request({
        method: 'post',
        url: 'w/bill/bindHouseFee',
        data: {}
    })
}

export function getFundList() {
    return request({
        method: 'post',
        url: 'w/fund/getList',
        data: {}
    })
}

export function getNewYearEvent2022Config(activityId) {
    return request({
        method: 'post',
        url: 'w/newYearEvent2022/config',
        data: {
            activity_id: activityId,
        }
    })
}

export function getNewYearEvent2022Link(activityId) {
    return request({
        method: 'post',
        url: 'w/newYearEvent2022/openApp',
        data: {
            activity_id: activityId,
        }
    })
}

export function getNewYearEvent2022Gift(activityId) {
    return request({
        method: 'post',
        url: 'w/newYearEvent2022/getGift',
        data: {
            activity_id: activityId,
        }
    })
}

export function getTmsEventLink(activityId, plateNumber1, plateNumber2) {
    return request({
        method: 'post',
        url: 'w/tmsEvent/openApp',
        data: {
            activity_id: activityId,
            plate_number1: plateNumber1,
            plate_number2: plateNumber2,
        }
    })
}

export function registerTmsEvent(activityId, plateNumber) {
    return request({
        method: 'post',
        url: 'w/tmsEvent/register',
        data: {
            activity_id: activityId,
            plate_number: plateNumber,
        }
    })
}

export function getUserConfig() {
    return request({
        method: 'post',
        url: 'w/bill/getUserConfig',
        data: {}
    })
}

export function getTuitionFeeSupportSchools() {
    return request({
        method: 'post',
        url: 'w/bill/getTutitionFeeSupportSchools',
        data: {}
    })
}

export function getTvFeeStations() {
    return request({
        method: 'post',
        url: 'w/bill/kbro/getStations',
        data: {}
    })
}

export function getFubonInsuranceUrl() {
    return request({
        method: 'post',
        url: 'w/fubonInsurance/getFubonInsuranceUrl',
        data: {}
    })
}


export function getTvFeeBindingList() {
    return request({
        method: 'post',
        url: 'w/bill/kbro/getBindingList',
        data: {}
    })
}

export function bindKbroBillInformation(data) {
    return request({
        method: 'post',
        url: 'w/bill/kbro/bindBillInformation',
        data: data
    })
}

export function unbindKbroBillInformation(data) {
    return request({
        method: 'post',
        url: 'w/bill/kbro/unbindBillInformation',
        data: data
    })
}

export function queryBindItemList() {
    return request({
        method: 'post',
        url: 'w/bill/queryBindItemList',
        data: {}
    })
}

export function queryBindBillList(data) {
    return request({
        method: 'post',
        url: 'w/bill/queryBindBillList',
        data: data
    })
}

export function saveFavoriteEquipmentNumberOfTelcomFee(data) {
    return request({
        method: 'post',
        url: 'w/bill/telcomFee/saveFavoriteEquipmentNumber',
        data: data,
    })
}

export function queryFavoritequipmentNumberOfTelcomFee() {
    return request({
        method: 'POST',
        url: 'w/bill/telcomFee/queryFavoriteEquipmentNumber',
        data: {},
    })
}

export function deleteFavoritequipmentNumberOfTelcomFee(data) {
    return request({
        method: 'POST',
        url: 'w/bill/telcomFee/deleteFavoriteEquipmentNumber',
        data: data,
    })
}

export function queryFavoriteVehicleList() {
    return request({
        method: 'POST',
        url: 'w/bill/parkingFee/queryFavoriteVehicleList',
        data: {},
    })
}

export function queryParkingFeeBindingCityList() {
    return request({
        method: 'POST',
        url: 'w/bill/parkingFee/queryCityList',
        data: {},
    })
}

export function queryParkingFeeBindingList() {
    return request({
        method: 'POST',
        url: 'w/bill/parkingFee/queryBindingVehicleList',
        data: {},
    })
}

export function setActiveHealthyInsuranceNotification(data) {
    return request({
        method: 'POST',
        url: 'w/bill/setActiveHealthyInsuranceNotification',
        data: data,
    })
}